/**
 * Inject script node into the document. If the `id` argument is given,
 * the function ensures the existence of the script before injection.
 *
 * @param src - the source url of the script
 * @param [id] - script's unique identifier
 * @return {Promise<HTMLScriptElement>}
 */
export function injectScript(src, id = undefined) {
  if (id) {
    const script = document.getElementById(id);
    if (script) {
      return Promise.resolve(script);
    }
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;

    script.onload = () => resolve(script);

    script.onerror = (event) => {
      const error = new Error(`unable to inject async script [${src}]`);
      error.event = event;
      reject(error);
    };

    if (id) {
      script.id = id;
    }

    document.head.appendChild(script);

    return script;
  });
}
